import { inject, Injectable, signal } from '@angular/core';
import { matchesBinding } from './shortcut-matcher';
import type { EventqShortcutAction, EventqShortcutKeymap } from './shortcut.models';
import {
  EVENTQ_SHORTCUT_ACTIONS,
  EVENTQ_SHORTCUT_DEFAULT_KEYMAP,
  EVENTQ_SHORTCUT_KEYMAP_STORE,
} from './shortcut.tokens';

@Injectable()
export class EventqShortcutService {
  private readonly actions = inject(EVENTQ_SHORTCUT_ACTIONS);
  private readonly defaults = inject(EVENTQ_SHORTCUT_DEFAULT_KEYMAP);
  private readonly store = inject(EVENTQ_SHORTCUT_KEYMAP_STORE, { optional: true });

  private readonly actionById = new Map(this.actions.map((action) => [action.id, action]));

  /** Effective keymap: stored overrides win over defaults per action id. */
  readonly effectiveKeymap = signal<EventqShortcutKeymap>(this.mergeKeymap());

  resolve(event: KeyboardEvent): EventqShortcutAction | null {
    const keymap = this.effectiveKeymap();
    for (const action of this.actions) {
      const bindings = keymap[action.id] ?? [];
      if (bindings.some((binding) => matchesBinding(event, binding))) {
        return action;
      }
    }
    return null;
  }

  private mergeKeymap(): EventqShortcutKeymap {
    const stored = this.store?.load() ?? null;
    if (!stored) {
      return { ...this.defaults };
    }
    return { ...this.defaults, ...stored };
  }
}
